import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
import React from "react";
import { useFeatureFlag } from "../../launch-darkly";
import { NewTeamPage } from "./NewTeamPage";
import TeamSettingsPage from "./TeamSettingsPage";

export function TeamPage() {
  const [canAccessNewTeamPage, loading] = useFeatureFlag("NewTeamSettings");

  if (loading) {
    <div className="cw-flex cw-justify-center cw-items-center cw-h-screen">
      <CircularProgress variant="large" />
    </div>;
  }

  return canAccessNewTeamPage ? <NewTeamPage /> : <TeamSettingsPage />;
}
